import { useState } from "react";

import { Add } from "@mui/icons-material";
import { Box, Button, Drawer, Toolbar, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import Table from "../../components/Brand/BrandTable";

import { ToastContainer } from "react-toastify";

import { EditBrandDrawer } from "../../components/Brand/EditBrandDrawer";
import { UploadDrawer } from "../../components/CommonFunctions/UploadDrawer";

import { uploadExcel } from "../../apis/Brand";
import { FormDrawer } from "../../components/Form/FormDrawer";

const useStyles = makeStyles()((theme) => ({
	title: {
		flexGrow: 1,
		display: "none",
		[theme.breakpoints.up("sm")]: {
			display: "block",
		},
	},
}));

export const Brand = () => {
	const { classes } = useStyles();

	const [editOpen, setEditOpen] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [, setRows] = useState([]);
	const [brand, setBrand] = useState({});
	const [loading, setLoading] = useState(false);
	const [page] = useState(0);
	const [rowsCount] = useState(10);
	const [isUploadDrawerOpen, setIsUploadDrawerOpen] = useState(false);
	const [, setSelectedBrand] = useState({});

	const handleAdd = () => {
		setIsEdit(false);
		setBrand({ name: "", seller_market: "" });
		setEditOpen(true);
	};

	const handleEdit = (item) => {
		setIsEdit(true);
		setBrand(item);
		setEditOpen(true);
	};

	// useEffect(() => {
	//   getAdmitadToken();
	//   getAdSpaceId();
	// }, []);
	return (
		<Box p={2}>
			<Toolbar>
				<Typography className={classes.title} variant="h4" noWrap>
					Brands
				</Typography>
				<Button
					onClick={() => handleAdd()}
					startIcon={<Add />}
					variant="contained"
					color="primary"
				>
					Add Brand
				</Button>
			</Toolbar>
			<ToastContainer />
			<Box sx={{ px: 3 }}>
				<Table
					handleEdit={handleEdit}
					setSelectedBrand={setSelectedBrand}
					setIsUploadDrawerOpen={setIsUploadDrawerOpen}
				/>
				<FormDrawer
					open={editOpen}
					setEditOpen={setEditOpen}
					loading={loading}
				>
					<EditBrandDrawer
						rowsCount={rowsCount}
						page={page + 1}
						edit={isEdit}
						brand={brand}
						setEditOpen={setEditOpen}
						setBrand={setBrand}
						setRows={setRows}
						setLoading={setLoading}
					/>
				</FormDrawer>
				<Drawer
					anchor="right"
					open={isUploadDrawerOpen}
					onClose={() => setIsUploadDrawerOpen(false)}
				>
					<UploadDrawer
						isFromBrand={true}
						uploadExcel={uploadExcel}
						setIsUploadDrawerOpen={setIsUploadDrawerOpen}
					/>
				</Drawer>
			</Box>
		</Box>
	);
};
